import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {MultiLocationOrderSummaryContainer} from '../../../../../features/OrderSummary/MultiLocationOrderSummaryContainer'
import {
  selectLocations,
  selectSelectedLocationId,
  selectIsUpgrade,
  updateLocation,
} from '../../../../../app-store/PurchaseLinkSlice'
import {selectEffectiveRole} from '../../../../../app-store/selector'
import {usePurchaseLinkProducts} from '../hooks/usePurchaseLinkProducts'
import {usePurchaseLinkPaymentPreview} from '../hooks/usePurchaseLinkPaymentPreview'
import {usePurchaseLinkPreloadAllLocations} from '../hooks/usePurchaseLinkPreloadAllLocations'

// Account-header "Create Purchase Link" flow's Order Summary — every
// parent-pay location from ParentPayLocationSelector's dropdown, each its
// own accordion, combined total. See MultiLocationOrderSummaryContainer for
// why editing stays scoped to whichever location is currently active.
export function ParentPayOrderSummary({actions}) {
  const dispatch = useDispatch()
  const locations = useSelector(selectLocations)
  const selectedLocationId = useSelector(selectSelectedLocationId)
  const activeLocation = locations.find(
    l => l.locationId === selectedLocationId,
  )
  const isUpgrade = useSelector(selectIsUpgrade)
  const effectiveRole = useSelector(selectEffectiveRole)
  const userRoles = [effectiveRole].flat().filter(Boolean)
  const {
    selectedCountry,
    selectedProducts,
    handleRemoveProduct,
    isNewTLMCAccessible,
    isNewCustomer,
  } = usePurchaseLinkProducts()
  const {refreshPaymentPreview} = usePurchaseLinkPaymentPreview()
  usePurchaseLinkPreloadAllLocations()

  return (
    <MultiLocationOrderSummaryContainer
      locations={locations}
      activeLocationId={selectedLocationId}
      selectedCountry={selectedCountry}
      selectedProducts={selectedProducts}
      handleRemoveProduct={handleRemoveProduct}
      isNewTLMCAccessible={isNewTLMCAccessible}
      isNewCustomer={isNewCustomer}
      isUpgrade={isUpgrade}
      applyNewAccountDefaults
      userRoles={userRoles}
      refreshPaymentPreview={refreshPaymentPreview}
      onUpdateItem={(locationId, changes) =>
        dispatch(updateLocation({locationId, changes}))
      }
      isActiveLocationLoaded={activeLocation?.isLoaded}
      flushEdges
      actions={actions}
    />
  )
}
